<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-14"><a id="_idTextAnchor014"></a>Cruciform</h2>
<p class="Verse-new">Rooted tree</p>
<p class="Verse-main">reaching up to heaven</p>
<p class="Verse-main">branches tendered wide</p>
<p class="Verse-main">sheltering, budding, laden.</p>
<p class="Verse-main">Is this you?</p>
<p class="Verse-new">Welling energies of love</p>
<p class="Verse-main">all held together </p>
<p class="Verse-main">in one upright man</p>
<p class="Verse-main">albeit touched </p>
<p class="Verse-main">by every open</p>
<p class="Verse-main">and unhealed wound.</p>
<p class="Verse-new">Crosspiece:</p>
<p class="Verse-main">shackled arms, hands,</p>
<p class="Verse-main">reach out</p>
<p class="Verse-main">with fiery gifts</p>
<p class="Verse-main">of love embracing</p>
<p class="Verse-main">each and every crushed</p>
<p class="Verse-main">forsaken soul.</p>
<p class="Verse-new">Streams </p>
<p class="Verse-last">of bloodied life</p>
<p class="Verse-last">lovely as a rainbow</p>
<p class="Verse-last">now hit the ground</p>
<p class="Verse-last">easing earth’s pain</p>
<p class="Verse-last">flowing on</p>
<p class="Verse-last">to fished-out oceans</p>
<p class="Verse-last">stitching up </p>
<p class="Verse-last">the tattered robes</p>
<p class="Verse-last">of a once-splendid</p>
<p class="Verse-last">mothered earth.</p>
<p class="Verse-new">All givens </p>
<p class="Verse-main">of a hospitality</p>
<p class="Verse-main">we once knew</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-16.vue?a51ecb32